import { memo } from 'react';

import { Text } from '@/lib/v2/components';

type EmptyStateProps = {
  text: string;
};

const EmptyState = ({ text }: EmptyStateProps) => {
  return (
    <div className="py-14">
      <Text alignment="center" color="gray" renderHtml={text} variant="text"></Text>
    </div>
  );
};

export default memo(EmptyState);
